<template>
  <div class="green-bg">
    <span class="title">{{pageTitle}}</span>
  </div>
</template>

<script>
  export default{
    name: 'v-title',
    props: {
      pageTitle: String
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import "../assets/scss/base.scss";

  .green-bg {
    position: relative;
    width: px2rem(430);
    height: px2rem(110);
    margin: 0 auto;
    color: white;
    @include bg-img('../assets/img/title_bg');
    .title {
      font-family: '黑体';
      position: absolute;
      left: px2rem(143);
      top: px2rem(17);
      font-size: px2rem(36);
      @include text-shadow(2, 2, rgba(28, 107, 101, 0.7))
    }
  }
</style>



// WEBPACK FOOTER //
// VTitle.vue?6b11ce79